// export const API_URL = "http://127.0.0.1:2000";
export const API_URL = `${window.location.origin}/api`;

export const IS_ROBOT = true;
